import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {SharedService} from './shared.service';


export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}


@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate>{
  closeAction: Subject<boolean>;

  constructor(private sharedService: SharedService) {
    this.closeAction = new Subject<boolean>();
  }

  canDeactivate(component: ComponentCanDeactivate, currentRoute: ActivatedRouteSnapshot,
                currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!component) {
      return true;
    } else {
      return component.canDeactivate() ? true : this.showConfirmation();
    }
  }

  showConfirmation() {
    this.sharedService.showNotification({
      title: 'Unsaved changes',
      message: 'Are you sure you want to leave this page? Unsaved changes will be lost.',
      actions: [
        {
          text: 'Cancel',
          callback: () => {
            this.closeAction.next(false);
          }
        }, {
          text: 'OK',
          callback: () => {
            this.closeAction.next(true);
          }
        }
      ]
    });
    return this.closeAction;
  }

}
